import axios from "axios";

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

const ProcessingStatement = {
    async create(statement_hostel) {
        get_token();
        try {
            return await axios.post(
                '/statement_hostel/pichers/stm_hostel_settler',
                { statement_hostel }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async show() {
        get_token();
        try {
            return await axios.get(
                '/statement_hostel/pichers/stm_hostel_settler/:id'
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async update(statement_hostel_id, statement_hostel) {
        get_token();
        try {
            return await axios.put(
                `/statement_hostel/pichers/stm_hostel_settler/${ statement_hostel_id }`,
                {
                    array_place_hostel: statement_hostel.array_place_hostel,
                    gender:  statement_hostel.gender,
                    curr_phone: statement_hostel.curr_phone
                }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async delete(statement_hostel_id) {
        get_token();
        try {
            return await axios.delete(
                `/statement_hostel/pichers/stm_hostel_settler/${ statement_hostel_id }`
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async get_last_actual_statement() {
        get_token();
        try {
            return await axios.get(
                '/statement_hostel/pichers/stm_hostel_settler/last_actual_statement'
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async get_all_comment_statement(statement_hostel_id) {
        get_token();
        try {
            return await axios.get(
                `/statement_hostel/pichers/comments/${statement_hostel_id}`,
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async get_curr_place_hostel() {
        get_token();
        try {
            return await axios.get(
                '/statement_hostel/pichers/stm_hostel_settler/get_curr_place_hostel',
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },

}

export default ProcessingStatement;